<div class="mercer-referenced-container">
    <p>Mercer AI has referenced:</p>
    <div class="buttons-container">
        <ng-container *ngIf="isCase1">
            <button>
                <img src="../../../../assets/icons/compass.svg" alt="" /> Job Architecture Tool
            </button>
            <button>
                <img src="../../../../assets/icons/Briefcase-Purple.svg" alt="" />
                Mercer Job Library
            </button>
            <button>
                <img src="../../../../assets/icons/Focus-Purple.svg" alt="" />
                Skills Edge
            </button>
            <button>
                <img src="../../../../assets/icons/Profit-Purple.svg" alt="" />
                IPE
            </button>
        </ng-container>
        <ng-container *ngIf="!isCase1">
            <button>
                <img src="../../../../assets/icons/compass.svg" alt="" />
                Knowledge Exchange
            </button>
            <button>
                <img src="../../../../assets/icons/Briefcase-Purple.svg" alt="" />
                Sales Enablement - MercerLink
            </button>
        </ng-container>
    </div>
</div>
